<script>
export default {
    name: 'OrderDetailsEcxpenseCodes',
    props: {
        model: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        distribution() {
            return this.model.distribution
        },
        defaulsCode() {
            return this.model.codes.default
        },
        secondaryCodes() {
            return Object.entries(this.model.codes).reduce((p, [key, value]) => {
                if (key !== 'default' && value) p.push(value)
                return p
            }, [])
        },
    },
}
</script>

<template lang="pug">
.d-flex.flex-column
    .d-flex.justify-content-between.align-items-center
        span.font-size-base() {{defaulsCode}}
        span.badge.badge-f1.font-weight-semibold {{ distribution }}%    
    span.font-size-micro.text-62.mt-2(v-for="code in secondaryCodes") {{code}}

</template>
